/*
  sp-ranking-labels.js
  Rank King widget (.ranking-list / .ranking-item__card): injects product tag labels
  (reservation / SELECTED LINE / SETUP) above each ranking title.
  Vanilla port of the legacy cbs-ranking-labels.js. Idempotent, safe when the widget is absent.
  Label markup matches snippets/product-tag-labels (.tag_label-group .tag_label); styles live in layout/theme.liquid.
*/
(function () {
  'use strict';

  if (window.__spRankingLabels) return;
  window.__spRankingLabels = true;

  var cache = new Map();
  var processTimer = null;
  var retryTimer = null;
  var retryCount = 0;
  var RETRY_MAX = 10;
  var observer = null;
  var observed = new WeakSet();

  function createLabel(modifier, text) {
    var wrapper = document.createElement('div');
    var span = document.createElement('span');
    wrapper.className = 'tag_label ' + modifier;
    span.textContent = text;
    wrapper.appendChild(span);
    return wrapper;
  }

  function buildGroup(tags) {
    var reservation = tags.indexOf('予約商品') !== -1;
    // SELECTED LINE is hidden on the top page rails (client request 2026-10-13), so the ranking follows suit
    var selectedLine = false;
    var setupText = null;
    if (tags.indexOf('#セットアップ可能') !== -1) setupText = 'SETUP可能';
    else if (tags.indexOf('#セットアップ') !== -1) setupText = 'SETUP';

    if (!reservation && !selectedLine && !setupText) return null;

    var group = document.createElement('div');
    group.className = 'tag_label-group tag_label-group--ranking';
    if (reservation) group.appendChild(createLabel('-reservation', '予約商品'));
    if (selectedLine) group.appendChild(createLabel('-setup', 'SELECTED LINE'));
    if (setupText) group.appendChild(createLabel('-setup', setupText));
    return group;
  }

  function fetchTags(handle) {
    if (cache.has(handle)) return cache.get(handle);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        return response.json();
      })
      .then(function (product) {
        return product.tags || [];
      })
      .catch(function (error) {
        console.error('Failed to inject ranking labels:', error);
        return null;
      });

    cache.set(handle, request);
    return request;
  }

  function injectLabels(card) {
    var link = card.querySelector('.ranking-item__link');
    var title = card.querySelector('.ranking-item__title');
    if (card.querySelector('.tag_label-group--ranking') || !link || !title) return;

    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#\s]+)/);
    if (!match) return;

    var handle;
    try {
      handle = decodeURIComponent(match[1]);
    } catch (e) {
      handle = match[1];
    }

    fetchTags(handle).then(function (tags) {
      if (!tags || card.querySelector('.tag_label-group--ranking')) return;
      var group = buildGroup(tags);
      if (group && title.parentNode) title.parentNode.insertBefore(group, title);
    });
  }

  function processCards() {
    document.querySelectorAll('.ranking-item__card').forEach(function (card) {
      if (card.dataset.labelInjected === 'true') return;
      card.dataset.labelInjected = 'true';
      injectLabels(card);
    });
  }

  function scheduleProcess() {
    clearTimeout(processTimer);
    processTimer = setTimeout(processCards, 120);
  }

  function observeLists() {
    var lists = document.querySelectorAll('.ranking-list');

    if (lists.length === 0) {
      // The widget renders late; retry a few times, then give up on pages without it.
      if (retryCount >= RETRY_MAX) return;
      if (retryCount >= 2 && !document.querySelector('.ranking-item__card')) return;
      retryCount++;
      clearTimeout(retryTimer);
      retryTimer = setTimeout(observeLists, 300);
      return;
    }

    if (!observer) observer = new MutationObserver(scheduleProcess);
    lists.forEach(function (list) {
      if (observed.has(list)) return;
      observed.add(list);
      observer.observe(list, { childList: true, subtree: true });
    });
    processCards();
  }

  function init() {
    processCards();
    observeLists();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
